/**Dependencies */
import React, { useState } from "react";
import useForm from "../hooks/useForm";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import {
  Container,
  Button,
  Modal,
  Row,
  Col,
  Form,
  Card,
} from "react-bootstrap";
import { CardsProducts } from "../components/CardsProducts";
import { planSegurosData } from "../helpers";
import Swal from "sweetalert2";

/**Styles */
import "../styles/seguroViajero.scss";

/**Images */
import bannerExperiencia from "../images/banners/Banner seguro experiencia.png";
import formSeguro from "../images/banners/form seguro.png";

import iconAcompañamiento from "../images/icons/Acompañamiento médico.png";
import iconTrayectos from "../images/icons/Entre trayectos.png";
import iconInformacion from "../images/icons/Línea de información.png";
import iconMascotas from "../images/icons/Mascotas protegidas.png";

// Services
import { getEmailText } from "../services/emailService";

export const SeguroViajero = () => {
  const [showModal, setShowModal] = useState(false);
  const [infoPlans, setInfoPlans] = useState("");
  let initialState = {
    emailAddress: "info@tranet.com.mx",
    destinatarioCC: "hola@marketingdirigido.com",
    asunto: "Han Solicitado información",
    fullName: "",
    email: "",
    phone: "",
    message: "",
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit, resetForm } = useForm(
    initialState,
    validations
  );

  const submitForm = async () => {
    const dataArray = {
      destinatario: formData.emailAddress,
      destinatarioCC: formData.destinatarioCC,
      asunto: formData.asunto,
      mensaje: `Nombre Completo: ${formData.fullName} \nEmail: ${formData.email} \nNúmero de Teléfono: ${formData.phone} \nMensaje: ${formData.message}`, // Usa la interpolación correctamente
    };

    try {
      await getEmailText(dataArray);
      resetForm();
      Swal.fire({
        title: "Correo enviado exitosamente!",
        text: "El correo ha sido enviado, nos contactaremos con usted lo antes posible.",
        icon: "success",
      });
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      Swal.fire({
        icon: "error",
        title: "Hubo un error al enviar el correo.",
        text: "Por favor intentelo mas tarde.",
      });
    }
  };
  const handleOpenModal = (content) => {
    setInfoPlans(content);
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const sections = [
    {
      icon: iconAcompañamiento,
      title: "Acompañamiento médico",
      description: "Antes, durante y después de tu viaje.",
      width: "55%",
    },
    {
      icon: iconTrayectos,
      title: "Entre trayectos",
      description:
        "Asistencia por pérdida de documentos, de equipaje, de conexión de vuelos y más.",
      width: "85%",
    },
    {
      icon: iconInformacion,
      title: "Línea de información",
      description: "Estamos 24 horas para ti y los tuyos, todo el año.",
      width: "65%",
    },
    {
      icon: iconMascotas,
      title: "Mascotas protegidas",
      description:
        "Contamos con orientación para viaje con mascotas y servicios clave.",
      width: "80%",
    },
  ];

  return (
    <div className="seguro-viajero">
      <PrincipalBanner idElemento={8} />
      <Container className="py-5">
        <div className="text-center">
          <h1 className="section-title outline mb-5">Seguro de viaje</h1>
          <p
            className="section-subtitle text-center"
            style={{ textAlign: "start" }}
          >
            Somos International Travel Net, una agencia de viajes trabajando con{" "}
            <strong>Continental Assist</strong> para respaldar de forma integral
            y segura tus experiencias de viajes.
          </p>
        </div>
      </Container>
      <div className="py-5" style={{ width: "100%" }}>
        <img
          src={bannerExperiencia}
          alt="Banner años de experiencia"
          style={{ width: "100%" }}
        />
      </div>

      <Container className="pt-5">
        <div className="text-center">
          <h1 className="section-title mb-5">Conoce los planes</h1>
        </div>
      </Container>

      <div className="container mb-5">
        <div className="d-flex justify-content-around flex-wrap">
          <Row>
            {planSegurosData.map((card, index) => (
              <Col md={4} sm={12} key={index + 1}>
                <CardsProducts
                  infoCards={card}
                  type={"seguro"}
                  handleShowModal={handleOpenModal}
                />
              </Col>
            ))}
          </Row>
        </div>
        <Modal
          size="lg"
          show={showModal}
          onHide={handleCloseModal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            {infoPlans &&
              infoPlans.map((info, index) => (
                <div className="info-plan" key={index + 1}>
                  <div className="header">
                    <h1>{info.title}</h1>
                  </div>
                  <div className="sub-header">Beneficios</div>
                  <div className="content">
                    {info.sections.map((item, index) => (
                      <div className="section">
                        <h2>{info.sections[index].subtitle}</h2>
                        <ul>
                          {item.items.map((items, index) => (
                            <li key={index + 1}>
                              <span>{items.description}</span>
                              <span className="amount">{items.price}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn-blue"
              style={{ width: "15%", height: "35px", fontSize: "15px" }}
              onClick={handleCloseModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <div className="section-asistencias" style={{ width: "100%" }}>
        <Row
          className="justify-content-center text-center"
          style={{ width: "100%" }}
        >
          {sections.map((section, index) => (
            <Col key={index} xs={12} md={3} className="mb-4">
              <Card className="p-3">
                <div className="section-asistencias__roundend-icon">
                  <img
                    src={section.icon}
                    style={{ width: section.width }}
                    alt="icon asistencia"
                  />
                </div>
                <Card.Body>
                  <Card.Title>{section.title}</Card.Title>
                  <br />
                  <Card.Text>{section.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <div
        className="py-5 container"
        style={{ position: "relative", height: "600px" }}
      >
        <img
          src={formSeguro}
          alt="Imagen"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "10px",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "50%",
            right: "5%",
            transform: "translateY(-50%)",
            backgroundColor: "transparent",
            padding: "30px",
            borderRadius: "10px",
            width: "80%",
            maxWidth: "600px",
            textAlign: "start",
            color: "white",
          }}
        >
          <h2 style={{ fontSize: "30px" }}>Cotiza tu seguro.</h2>
          <br />
          <Form onSubmit={(e) => handleSubmit(e, submitForm)}>
            <Row className="g-4">
              <Col xs={12} md={12}>
                <Form.Group controlId="formNombre">
                  <Form.Label>Nombre Completo</Form.Label>
                  <Form.Control
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formCorreo">
                  <Form.Label>Correo Electrónico</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>
                <Form.Group controlId="formTelefono">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    maxLength={10}
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>

                {/* <Form.Group controlId="formEdad">
                        <Form.Label>Edad</Form.Label>
                        <Form.Control type="text" maxLength={2} name="age" value={formData.age} onChange={handleChange} className='input-light text-white' required/>
                      </Form.Group> */}

                <Form.Group controlId="formDuracion">
                  <Form.Label>Mensaje</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    onChange={handleChange}
                    value={formData.message}
                    className="input-light text-white"
                    required
                  />
                </Form.Group>
                <div className="d-flex justify-content-center">
                  <Button
                    className="btn-white"
                    type="submit"
                    style={{
                      width: "20%",
                      height: "35px",
                      marginTop: "25px",
                      fontSize: "14px",
                    }}
                  >
                    Cotiza
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
};
